<div class="grouped-search-select" [class.grouped-search-select--compact]="compact" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <mat-form-field appearance="outline" class="grouped-search-select__field">
    <mat-label>{{ label | translate }}</mat-label>
    <input
      matInput
      readonly
      class="grouped-search-select__trigger-input"
      [disabled]="disabled"
      [value]="selectedValue ? displayValue : ('' | translate)"
      [placeholder]="noneOptionLabel | translate"
      (click)="togglePanel()" />
    <button mat-icon-button matSuffix type="button" [disabled]="disabled" (click)="togglePanel()">
      <mat-icon>{{ isOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </mat-form-field>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'grouped-search-select__backdrop'"
    (backdropClick)="closePanel()"
    (detach)="closePanel()">
    <div class="grouped-search-select__panel" (click)="$event.stopPropagation()">
      <div class="grouped-search-select__search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          [placeholder]="searchPlaceholder | translate"
          (click)="onSearchInput($event)"
          (ngModelChange)="onSearchTermChange()"
          (keydown)="$event.stopPropagation()" />
      </div>

      <div class="grouped-search-select__list" #panelList>
        <button
          type="button"
          class="grouped-search-select__option grouped-search-select__option--none"
          [class.grouped-search-select__option--selected]="!selectedValue"
          (click)="selectNone($event)">
          <span>{{ noneOptionLabel | translate }}</span>
          @if (!selectedValue) {
            <mat-icon color="primary">check</mat-icon>
          }
        </button>

        @for (group of visibleGroups; track group.id) {
          <div class="grouped-search-select__group">
            <button
              type="button"
              class="grouped-search-select__group-header"
              [class.grouped-search-select__group-header--expanded]="isGroupExpanded(group.id)"
              (click)="toggleGroup(group.id, $event)">
              <span>{{ group.label }}</span>
              <mat-icon>{{ isGroupExpanded(group.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            @if (isGroupExpanded(group.id)) {
              @for (item of group.items; track item.value) {
                <button
                  type="button"
                  class="grouped-search-select__option grouped-search-select__option--item"
                  [attr.data-value]="item.value"
                  [class.grouped-search-select__option--selected]="selectedValue === item.value"
                  (click)="selectItem(item.value, $event)">
                  <span>{{ item.label }}</span>
                  @if (selectedValue === item.value) {
                    <mat-icon color="primary">check</mat-icon>
                  }
                </button>
              }
            }
          </div>
        }

        @if (isSearchActive && visibleGroups.length === 0) {
          <div class="grouped-search-select__empty">
            {{ 'sin-resultados' | translate }}
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
